import React, { useState, useEffect } from 'react'
import {
    InputBase,
    Grid,
    Button
} from "@material-ui/core";
import useStyles from "./styles";
import { SearchOutlined as SearchIcon } from '@material-ui/icons';
import ClearIcon from '@material-ui/icons/Clear';
import SearchGrid from '../../../components/table/SearchGrid';
import Breadcrums from '../../../components/BreadCrums/breadcrums';
import TopSpacer from '../../../components/Common/spacer/TopSpacer';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import { PostDataAPI } from '../../../Services/APIService';
import Loader from '../../../components/Loader/Loader';
import { ActionDialog } from "../../../components/ActionDialog/ActionDialog";
import { withSnackbar } from "../../../components/Message/Alert";
import AddNewRole from './components/addNewRole';
import { saveActivlityLogInfo } from '../../../components/Common/Extensions';



function Roles({ trackingType, roleType, ...props }) {
    const classes = useStyles();
    const { showMessage } = props;
    const [editItem, setEditItem] = useState({});
    const [addNewRoleDialog, setAddNewRoleDialog] = useState(false);

    const handleActionClick = (key, item) => {
        if (key === "addNotes") {
            setEditItem(item);
        }
        else if (key === 'viewNotes') {
            setEditItem(item);
        } else if (key === 'delete') {
            deleteRole(item);
        } else if (key === 'edit') {
            editRole(item);
        }
    }


    //action dialog
    const [actiondialogState, setActionDialogState] = useState({
        showHide: false, type: "confirm", message: "",
    })

    const showActionDialog = (message, type, OnOkCallback, OnCancellCallback) => {
        setActionDialogState(prevState => ({
            ...prevState,
            type: type,
            showHide: true,
            message: message,
            onClickOk: OnOkCallback,
            OnClickCancel: OnCancellCallback
        }));
    }
    const deleteRole = (item) => {
        logRoleActivity(
            "Role Delete Confirmation Opened",
            `User opened delete confirmation for ${getRoleSummary(item)}`
        );
        showActionDialog("Warning: Are you sure you want to delete this role?", "confirm", function () {
            var params = { roleId: item.roleId, customerId: parseInt(associateId) }
            setIsLoading(true);
            PostDataAPI("fwrole/delete", params, true).then((result) => {
                if (result.success) {
                    showMessage("Success", "User role '" + item.roleName+"' deleted successfully", "success", 3000);
                    loadRolsGrid();
                } else {
                    showMessage("Error", result.message, "error", 3000);
                }
                setIsLoading(false);
            })
        });
    }
    const editRole = (item) => {
        logRoleActivity(
            "Role Edit Dialog Opened",
            `User opened edit role dialog for ${getRoleSummary(item)}`
        );
        setEditItem(item);
        setAddNewRoleDialog(true);
    }
    const closeAddRole = () => {
        setEditItem({});
        setAddNewRoleDialog(false);
    }
    const handleSuccessClose = (message) => {
        setEditItem({});
        closeAddRole();
        showMessage("Success", message, "success", 3000);
        loadRolsGrid();
    }
    const addRole = () => {
        logRoleActivity(
            "Role Add Dialog Opened",
            `User opened add role dialog for ${getRoleTypeLabel()} roles`
        );
        setEditItem({});
        setAddNewRoleDialog(true);
    }
    const [isDataGridUpdate, setIsDataGridUpdate] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const [rolesData, setRolesData] = useState([]);


    const handleDataGridUpdate = () => {
        setIsDataGridUpdate(!isDataGridUpdate);
    }

    const [searchFilter, setValue] = useState('');
    const handleSearch = (e) => {
        
        const currValue = e.target.value;
        if (currValue.trim().length > 0 || currValue == '') {
            setValue(currValue);
            handleDataGridUpdate()
        }
    }
    // Function to clear the input field
    const handleClearInput = (name) => {
        
        if (searchFilter.trim())
            logRoleActivity(
                "Role Search Cleared",
                `User cleared role search filter "${searchFilter.trim()}"`
            );
        setValue('');
        handleDataGridUpdate();
    };
    const userInfoJson = sessionStorage.getItem('user_info');
    const userInfo = JSON.parse(userInfoJson);
    const associateId = userInfo.user.associateId;
    const accountNumber = userInfo.user.accountNumber;
    const getRoleTypeLabel = () => roleType == 'customer_portal' ? 'Customer Portal' : 'Service Portal';
    const getRoleSummary = (item) => {
        const roleName = item?.roleName || "selected role";
        return item?.roleId ? `role ${roleName} (Role ID: ${item.roleId})` : `role ${roleName}`;
    };
    const logRoleActivity = (activity, details) => {
        saveActivlityLogInfo("Role Setup", activity, details, accountNumber, associateId);
    };
    const logRoleSearch = () => {
        if (!searchFilter.trim())
            return;

        logRoleActivity(
            "Role Search Filter Applied",
            `User searched ${getRoleTypeLabel()} roles for "${searchFilter.trim()}"`
        );
    };
    const loadRolsGrid = () => {
        var params = {
            roleType: roleType,
            customerId: associateId,
            loadDefault: "true"
        };
        setIsLoading(true);
        PostDataAPI("fwrole/loadGrid",params).then((result) => {
            if (result.success && result.data != null) {
                setRolesData(result.data.map((item) => {
                    item.roleType = item.roleType == 'customer_portal' ? 'Customer Portal' : 'Customer Portal'
                    return {...item}
                }));
            }
            else {
                setRolesData([]);
            }
            handleDataGridUpdate();
            setIsLoading(false);

        })
    }
    useEffect(() => {
        console.log(roleType)
        loadRolsGrid();
        
    }, [roleType]);

    return (
        <>
            {isLoading ? <Loader></Loader> : ''}
            <TopSpacer></TopSpacer>

            <div className={classes.header}>

                <Grid container alignItems="baseline">
                    <Grid item lg={12}>
                        <Breadcrums parentLink={"Setup"} currentLink={roleType == 'customer_portal'?'Roles':"User Roles"} isBack={true}></Breadcrums>
                    </Grid>
                </Grid>
            </div>

            {<Grid container className={classes.container}>
                <h1 className={classes.heading}>
                    {roleType == 'customer_portal'?'Roles':'Service Portal Roles'}
                </h1>
            </Grid>}



            <Grid row className={classes.gridHeader}>
                <div className={classes.gridActions}>
                    <Button className={classes.changeBtn} onClick={() => addRole()}><AddCircleOutlineIcon style={{ marginRight: '6px' }} /> Add New</Button>
                </div>
                <div className={classes.gridActions} style={{ marginRight: '7px' }} >
                    <InputBase
                        value={searchFilter}
                        placeholder="Search"
                        className="grid-search-input"
                        endAdornment={searchFilter ? <ClearIcon style={{ cursor: 'pointer' }} onClick={() => { handleClearInput('search') }} /> : ''}
                        startAdornment={<SearchIcon />}
                        onChange={handleSearch}
                        onBlur={logRoleSearch}
                        autoComplete={'off'}
                    />
                </div>

            </Grid>



            <Grid row className={classes.container} >
                <SearchGrid columns="roles"
                    list={rolesData}
                    noRecordMsg="No record exists"
                    Icon={true}
                    isUpdate={isDataGridUpdate}
                    filter={searchFilter}
                    onDeleteClick={deleteRole}
                    onEditClick={editRole}
                    onActionClick={handleActionClick}
                />
            </Grid>

            {addNewRoleDialog ?
                <AddNewRole
                    dialogOpenClose={addRole}
                    handleClose={closeAddRole}
                    handleSuccessClose={handleSuccessClose}
                    data={editItem}
                    roleType={roleType}
                ></AddNewRole>
                : ''}

            <ActionDialog
                type={actiondialogState.type}
                message={actiondialogState.message}
                actiondialogOpenClose={actiondialogState.showHide}
                onSubmit={actiondialogState.onClickOk}
                onCancel={() =>
                    setActionDialogState(prevState => ({
                        ...prevState, showHide: false
                    }))
                }
                onClose={() => setActionDialogState(prevState => ({
                    ...prevState, showHide: false
                }))

                }
            />

        </>
    )

}

export default withSnackbar(Roles);
